export const ANIMATION_DELAYS = {
  GIFT_ANIMATION: 1500,
  STREAM_PREPARATION: 10000,
  STREAM_REFRESH_1: 15000,
  STREAM_REFRESH_2: 25000,
  POSITION_MEASUREMENT: 100,
  LIKES_GIF_DISPLAY: 1000,
  SCROLL_DELAY: 100,
  INPUT_FOCUS_DELAY: 100,
} as const;

export const GIFT_ANIMATION_POSITIONS = {
  MOBILE: {
    START: { x: 200, y: 600 },
    PLAYER_1: { x: 80, y: 180 },
    PLAYER_2: { x: 160, y: 180 },
    BOTH: { x: 240, y: 180 },
  },
  DESKTOP: {
    START: { x: 800, y: 500 },
    PLAYER_1: { x: 120, y: 260 },
    PLAYER_2: { x: 120, y: 320 },
    BOTH: { x: 120, y: 380 },
  },
} as const;

export const STREAM_HEIGHTS = {
  MOBILE_MIN: 180,
  MOBILE: 224,
  DESKTOP: 385,
  CHAT: {
    MOBILE: 200,
    DESKTOP: 500,
  },
} as const;

export const TOKEN_PACKAGES = [
  { tokens: 65, price: "£0.89", exchangeRate: "£0.0145" },
  { tokens: 330, price: "£4.49", exchangeRate: "£0.0145" },
  { tokens: 660, price: "£8.99", exchangeRate: "£0.0145" },
  { tokens: 1321, price: "£17.99", exchangeRate: "£0.0145" },
  { tokens: 3303, price: "£44.99", exchangeRate: "£0.0151" },
  { tokens: 6607, price: "£90.90", exchangeRate: "£0.0151" },
  { tokens: 16500, price: "£224.99", exchangeRate: "£0.0151" },
] as const;

export const SOCIAL_MEDIA_OPTIONS = [
  { id: 1, name: "Instagram" },
  { id: 2, name: "Whatsapp" },
  { id: 3, name: "Twitter" },
  { id: 4, name: "Facebook" },
] as const;

export const ERROR_MESSAGES = {
  STREAM_STATUS_LOADING: "Please wait for the event status to load.",
  EVENT_ENDED: "The event has ended. Gifts cannot be sent anymore.",
  INSUFFICIENT_TOKENS: "Insufficient tokens to send this gift. Please recharge.",
  SELECT_PLAYER: "Please select a single player to send the gift.",
  EMPTY_MESSAGE: "Please enter a message",
  SEND_MESSAGE_ERROR: "Unable to send message. Try reloading the stream.",
  STREAMING_NOT_AVAILABLE: "Cannot select individual players until both streams are available.",
} as const;

export const SUCCESS_MESSAGES = {
  LINK_COPIED: "Link copied to clipboard",
} as const;